import { Button } from "antd";
import styled from "styled-components";

export const StyledSPModalControls = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
    padding-top: 16px;
`;

export const StyledSPModalButtonConfirm = styled(Button)`
    height: 50px;
    width: 100%;
    background-color: #52c41a;
`;

export const StyledSPTextarea = styled.div`
    position: relative;
    margin-top: 20px;
    .ant-upload-select {
        position: absolute;
        top: 10px;
        right: 10px;
    }
`;
